import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { fetchList } from './fetchList';

// Filters
type UseSubFilterReferralListActionOptions = UseMutationOptions<
  any,
  unknown,
  UseSubFiltersReferralLitesActionParams
>;

type UseSubFiltersReferralLitesActionParams = {
  filter: string;
  query: string;
};

export const useFiltersReferralLites = (
  options?: UseSubFilterReferralListActionOptions,
) => {
  return useMutation<any, unknown, any>({
    mutationFn: (params) => filtersReferralLitesAction(params?.unitId),
    onSuccess: (data, variables, onMutateResult, context) => {
      if (options?.onSuccess) {
        options.onSuccess(data, variables, onMutateResult, context);
      }
    },
  });
};

/**
 * Fetch the dashboard filter values.
 *
 * `unitId` scopes them to a single unit's dashboard. Without it the backend
 * aggregates over every unit the user belongs to, which is what a personal dashboard
 * needs but which surfaced values from other offices when displayed inside a unit
 * dashboard.
 */
export const filtersReferralLitesAction = (unitId?: string) => {
  return fetchList({
    queryKey: [
      'referrallites/filters',
      ...(unitId ? [{ unit_id: unitId }] : []),
    ],
    meta: undefined,
  } as any);
};
